import { getAjaxData } from "../functions/ajax-get-data";
import { loaderInstanse } from "../functions/scripts/loaderInstanse";

document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('.js-infinite-articles');
    
    // Тихий выход, если контейнера нет
    if (!container) return;

    // Лог инициализации только на нужной странице
    console.log('LOG: Infinite Articles Init');

    const { ajax_url, nonce } = window.ajax_params || {};
    let currentPage = 1;
    let isLoading = false;
    let hasMore = true;

    const sentinel = document.createElement('div');
    sentinel.className = 'articles-sentinel';
    sentinel.style.height = '1px';
    container.after(sentinel);

    const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && !isLoading && hasMore) {
            console.log('LOG: Articles Trigger loading page', currentPage + 1);
            loadNextPage();
        }
    }, { rootMargin: '0px 0px 200px 0px' });

    observer.observe(sentinel);

    function loadNextPage() {
        isLoading = true;
        const nextPage = currentPage + 1;
        
        loaderInstanse(container, true);

        const currentIds = Array.from(container.querySelectorAll('.blog-list__item'))
                                .map(item => item.getAttribute('data-id'))
                                .filter(Boolean);

        getAjaxData(ajax_url, 'get_articles', {
            nonce: nonce,
            page: nextPage,
            exclude: currentIds.join(',')
        }, (res) => {
            console.log('LOG: Articles Server Response:', res);

            if (res.success && res.data.html.trim() !== "") {
                const temp = document.createElement('div');
                temp.innerHTML = res.data.html;
                const newItems = Array.from(temp.children);

                newItems.forEach((item, index) => {
                    item.classList.add('ajax-loaded');
                    container.appendChild(item);

                    setTimeout(() => {
                        item.classList.add('is-visible');
                    }, index * 100); 
                });

                currentPage = nextPage;
                hasMore = res.data.more;
                console.log('LOG: Articles Page Loaded. More posts?', hasMore);
            } else {
                console.log('LOG: No more articles or error');
                hasMore = false;
                observer.unobserve(sentinel);
            }

            setTimeout(() => {
                loaderInstanse(container, false);
                isLoading = false;
            }, 300);
        });
    }
});